export const avatar = {
  root: {
    width: "28px",
    height: "28px",
    fontSize: "{content.font.size}",
    background: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
  },
  icon: {
    size: "{content.font.size}",
  },
  group: {
    borderColor: "{content.background}",
    offset: "-0.75rem",
  },
  lg: {
    width: "44px",
    height: "44px",
    fontSize: "1.5rem",
    icon: {
      size: "1.5rem",
    },
    group: {
      offset: "-1.5rem",
    },
  },
  xl: {
    width: "66px",
    height: "66px",
    fontSize: "2rem",
    icon: {
      size: "2rem",
    },
    group: {
      offset: "-2rem",
    },
  },
  css: ({ dt }: any): string => `
    .p-avatar-circle {
      overflow: hidden;
    }

    .p-avatar-group.p-avatar-group-vertical {
      flex-direction: column;
    }

    .p-avatar-group.p-avatar-group-vertical .p-avatar + .p-avatar {
      margin-inline-start: unset;
      margin-block-start: ${dt("avatar.group.offset")};
    }

    .p-avatar-group.p-avatar-group-vertical .p-avatar-lg + .p-avatar-lg {
      margin-inline-start: unset;
      margin-block-start: ${dt("avatar.lg.group.offset")};
    }

    .p-avatar-group.p-avatar-group-vertical .p-avatar-xl + .p-avatar-xl {
      margin-inline-start: unset;
      margin-block-start: ${dt("avatar.xl.group.offset")};
    }
  `,
};
